import React from 'react';
import { Plus } from 'lucide-react';
import PrimaryButton from './PrimaryButton';

// Full-screen empty state for when a user has no garden zones yet.
// Inline SVG only — no external image assets required.
export default function ZoneEmptyState({ onAdd }) {
  return (
    <div className="px-6 py-10 flex flex-col items-center text-center">
      <PottedPlantSVG />
      <h2 className="mt-4 text-xl font-semibold text-garden-ink">Welcome to your garden</h2>
      <p className="mt-2 text-sm text-garden-muted max-w-xs">
        Add an area of your yard — a flower bed, a vegetable patch, the front walk.
        Snap a photo of it, then tap to place the plants that live there.
      </p>
      <div className="mt-6">
        <PrimaryButton onClick={onAdd}>
          <Plus size={18} /> Add your first area
        </PrimaryButton>
      </div>
    </div>
  );
}

function PottedPlantSVG() {
  return (
    <svg
      width="140"
      height="140"
      viewBox="0 0 140 140"
      fill="none"
      aria-hidden
      className="text-garden-primary"
    >
      <ellipse cx="70" cy="125" rx="36" ry="5" fill="currentColor" opacity="0.12" />
      <path d="M50 98h40l-4 22H54l-4-22Z" fill="currentColor" opacity="0.85" />
      <path d="M46 94h48v6H46z" fill="currentColor" />
      <path
        d="M70 94V50M70 82c-2-14-14-22-28-22 2 16 14 24 28 22Zm0 0c2-14 14-22 28-22-2 16-14 24-28 22Zm0-14c0-10 6-14 12-14-2 8-6 14-12 14Zm0 0c0-10-6-14-12-14 2 8 6 14 12 14Z"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="58" cy="62" r="2" fill="currentColor" opacity="0.6" />
      <circle cx="82" cy="62" r="2" fill="currentColor" opacity="0.6" />
    </svg>
  );
}
